import { createApp } from 'vue';
import App from './App.vue';
import './style.css';
import { TraceTailPlugin } from '@tracetail/vue';

const app = createApp(App);

// Configure TraceTail with demo API key
app.use(TraceTailPlugin, {
  apiKey: 'demo_key_for_showcase',
  endpoint: 'https://tracetail.io/api',
  caching: true,
  debug: true
});

app.mount('#app');
